module.exports = __webpack_public_path__ + "static/media/savonia.1c687231.png";